module.exports = "<div *ngIf=\"messages.length > 0\" class=\"alert alert-danger\" role=\"alert\">\n  <span *ngFor=\"let message of messages\">\n    {{ 'ERROR.' + message.code | translate }}\n    <span *ngIf=\"message.detailsForUser\">{{ message.detailsForUser }}</span>\n  </span>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/messagebox/messagebox.component.html
// module id = ./src/app/shared/messagebox/messagebox.component.html
// module chunks = main